export function getTextFontFamily() {
  let fontFamily = 'Lato'
  if (document.location.pathname === '/index_beta.ashx') {
    if (document.location.search.indexOf('inter') !== -1) {
      fontFamily = "'Inter'"
    } else if (document.location.search.indexOf('lato') !== -1) {
      fontFamily = "'Lato'"
    }
  }

  return fontFamily
}
